import axios from "axios";

const api = axios.create({
    baseURL: "https://wildberries-web-test.up.railway.app/api",
    // baseURL: "http://localhost:5001/api",
    headers: {
        "ngrok-skip-browser-warning": "true"
    }
});



export const createCheckoutSession = async (orderData) => {
    const response = await api.post("/payments/create-checkout-session", orderData);
    return response.data;
};

export const createVippsPayment = async (orderData) => {
    const response = await api.post("/payments/vipps-payment", orderData);
    return response.data;
}

export const fetchOrderBySessionId = async (sessionId) => {
    const response = await api.get(`/orders/session/${sessionId}`);
    return response.data;
};


export const fetchProducts = async () => {
    const response = await api.get("/products");
    return response.data;
}

export const getSingleProduct = async (id) => {
    const response = await api.get(`/products/${id}`)
    return response.data;
}

export const cancelPendingOrder = async (sessionId) => {
    const response = await api.post("/orders/cancel-payment", {sessionId});
    return response.data;
}